import { Controller } from "stimulus";
import * as basicLightbox from "basiclightbox";

export default class extends Controller {
  connect() {
    this.modal = basicLightbox.create(`
      <iframe style="width:100vw;height:61vw" src="${this.url}?&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen allowtransparency></iframe>
    `);

    if (location.hash && location.hash === `#${this.element.id}`) {
      this.show();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }
  }

  disconnect() {
    delete this.modal;
  }

  show(event) {
    if (event) event.preventDefault();
    this.modal.show();
  }

  get url() {
    return this.element.href.replace("/watch?v=", "/embed/");
  }
}
